import { Typography } from "@mui/material";
import ErrorModalImage from "assets/illustrations/errorModalImage.svg";
import { ModalContentWrapper } from "components/primitives/ModalContentWrapper";
import { ModalTitle } from "components/primitives/ModalTitle";
import { useTranslation } from "react-i18next";
import { ModalSupportFooter } from "../ModalSupportFooter";

type ErrorModalContentProps = {
	fridgeId: string;
	/** Already-translated title; defaults to `t("modals.error.title")`. */
	title?: string;
	/** Already-translated body; defaults to `t("modals.error.body")`. */
	body?: string;
};

export const ErrorModalContent = ({ fridgeId, title, body }: ErrorModalContentProps) => {
	const { t } = useTranslation();
	return (
		<ModalContentWrapper>
			<ModalTitle variant="promoHeader">{title ?? t("modals.error.title")}</ModalTitle>
			<Typography variant="promoText" mb={5}>
				{body ?? t("modals.error.body")}
			</Typography>
			<ErrorModalImage />
			<ModalSupportFooter fridgeId={fridgeId} />
		</ModalContentWrapper>
	);
};
